export default "__VITE_ASSET__5hJR3qvf__"